// @flow 
import * as React from 'react';
import {DatePicker, Form, Input, InputNumber, message, Popconfirm, Table, Tag, Typography} from "antd";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import type {ColumnsType} from "antd/es/table";
import moment from "moment/moment";
import {requestConfigList, requestGroupList, requestPutConfig} from "../../../axios/http";



interface Item {
    key: string;
    id: number;           // ID
    name: string;         // 属性名称（例如 app_version）
    value: string;        // 版本号值
    create_time: number;  // 创建时间，时间戳
}

interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
    editing: boolean;
    dataIndex: string;
    title: any;
    inputType: 'number' | 'text';
    record: Item;
    index: number;
    children: React.ReactNode;
}

const EditableCell: React.FC<EditableCellProps> = ({
                                                       editing,
                                                       dataIndex,
                                                       title,
                                                       inputType,
                                                       record,
                                                       index,
                                                       children,
                                                       ...restProps
                                                   }) => {
    const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;

    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{ margin: 0 }}
                    rules={[
                        {
                            required: true,
                            message: `Please Input ${title}!`,
                        },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};





export const Config = () => {


    const [form] = Form.useForm();
    const [data, setData] = useState<Item[]>([]);
    const [editingKey, setEditingKey] = useState('');

    const isEditing = (record: Item) => record.key === editingKey;

    const edit = (record: Partial<Item> & { key: React.Key }) => {
        form.setFieldsValue({ id: 0, name: '', value: '', create_time: '',...record });
        setEditingKey(record.key);
    };

    const cancel = () => {
        setEditingKey('');
    };

    const save = async (key: React.Key) => {
        try {
            const row = (await form.validateFields()) as Item;

            const newData = [...data];
            const index = newData.findIndex(item => key === item.key);
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {
                    ...item,
                    ...row,
                });
                requestPutConfig({
                    "app_version": newData[0].value
                }).then(()=>{
                    message.success('修改成功')
                }).catch(()=>{
                    message.error('修改失败')
                })
                setData(newData);
                setEditingKey('');
            } else {
                console.log(1313)
                newData.push(row);
                setData(newData);
                setEditingKey('');
            }
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };

    const columns = [
        {
            title: 'name',
            dataIndex: 'name',
            width: '25%',
            editable: true,
        },
        {
            title: 'Version',
            dataIndex: 'value',
            width: '15%',
            editable: true,
        },
        {
            title: 'create_time',
            dataIndex: 'create_time',
            width: '40%',
            editable: true,
            render: (_: any, record: Item) => {
                const editable = isEditing(record);
                return <div>{record.create_time&&moment(record.create_time).format('YYYY-MM-DD HH:mm:ss')}</div>
            }
        },
        {
            title: 'operation',
            dataIndex: 'operation',
            render: (_: any, record: Item) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
            <Typography.Link onClick={() => {
                save(record.key)
            }} style={{ marginRight: 8 }}>
              Save
            </Typography.Link>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <a>Cancel</a>
            </Popconfirm>
          </span>
                ) : (
                    <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                        Edit
                    </Typography.Link>
                );
            },
        },
    ];

    const mergedColumns = columns.map(col => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record: Item) => ({
                record,
                inputType: col.dataIndex === 'age' ? 'number' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });




    async function getConfigList(){
        let result = await requestConfigList()
        setData(result.data.config)
    }

    useEffect(() => {
        getConfigList()
    }, []);



    return (
        <div>
            <Form form={form} component={false}>
                <Table
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                    }}
                    bordered
                    dataSource={data}
                    columns={mergedColumns}
                    rowClassName="editable-row"
                    pagination={{
                        onChange: cancel,
                    }}
                />
            </Form>
        </div>
    );
};